<!-- @format -->
<script lang="ts">
  import Collapse from "~/components/fragment-sets/common/Collapse.svelte";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { campaign_theme, CATEGORY_NAVIGATION, CAMPAIGN_MAIN_NAVIGATION } from "./store";
  import type { CampaignNavigation } from "./store";

  export let request_store_key: StoresKey;
  const { reverse_router, site_page, i18nOf, nav_menus, T } =
    getStoresContext(request_store_key);
  let t = $T;
  $: categories =
    $nav_menus &&
    $nav_menus.find((nav) => nav.name == CATEGORY_NAVIGATION[$campaign_theme as keyof CampaignNavigation])
      ?.navigationMenuItems;
  $: current = $site_page?.friendlyUrlPath;
  $: active =
    (categories && categories.find((page) => current == page.link)) || null;
  $: main_header_pages =
    $nav_menus &&
    $nav_menus.find((nav) => nav.name == CAMPAIGN_MAIN_NAVIGATION[$campaign_theme as keyof CampaignNavigation])
      ?.navigationMenuItems;
  $: show_all_href =
    main_header_pages && main_header_pages.length
      ? $reverse_router.routePage(main_header_pages[0].link)
      : "/";
</script>

{#if categories && categories.length}
  <div class="col-12 col-lg-4 mb-3 d-lg-none">
    <Collapse open_by_default={false}>
      <button
        slot="open"
        class="py-2 d-flex w-100 me-2 justify-content-between purple-button fw-normal">
        {active ? i18nOf(active.name_i18n) : "Kategoriat"}
        <i class="fas fa-chevron-up" />
      </button>
      <button
        slot="close"
        class="py-2 d-flex w-100 me-2 justify-content-between purple-button fw-normal">
        {active ? i18nOf(active.name_i18n) : "Kategoriat"}
        <i class="fas fa-chevron-down" />
      </button>
      <div class="select">
        <a href={show_all_href}>{$T`show-all`}</a>
        {#each categories as page}
          <a
            href={page.link ? $reverse_router.routePage(page.link) : page.url}
            class:active={current == page.link}>{i18nOf(page.name_i18n)}</a>
        {/each}
      </div>
    </Collapse>
  </div>
{/if}

<style>
  .select {
    background-color: #fff;
    margin-top: 8px;
    max-height: 300px;
    overflow: auto;
  }
  .select a {
    display: block;
    border: none;
    background-color: transparent;
    color: #000;
    text-align: left;
    width: 100%;
    padding: 0.5rem 1rem;
  }
  .select a:hover {
    background-color: var(--brandColor2);
    color: #fff;
  }
  .active {
    font-family: "Archivo-Bold", sans-serif;
    background-color: var(--brandColor2) !important;
    color: #fff !important;

  }
</style>
